var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.documents.length)?_c('redesign-documents-list',{attrs:{"documents":_vm.documents}}):_c('p',[_vm._v("Отсутствуют прикрепленные документы")])
}
var staticRenderFns = []

export { render, staticRenderFns }